import type { MapDef } from '@warcarp/api-types'
import { getBundledMap } from './bundledMaps'

/** Older APIs/caches omit this optional cosmetic field. Do not replace their
 * geometry or game rules; borrow only the bundled selection default. */
export function mapInnerGlowEnabled(map: Pick<MapDef, 'id' | 'selectionInnerGlow'>): boolean {
  return map.selectionInnerGlow ?? getBundledMap(map.id)?.selectionInnerGlow ?? true
}
